<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row">
            <div class="row col-lg-6 col-sm-6 my-auto">
              <h4 class="mb-0 lg-bld">Manage Banners</h4>
            </div>
          </div>
        </div>
        <div
          class="page-content"
          v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage"
        >
          <div class="card-body py-0 px-2">
            <div class="row">
              <div class="col-lg-12 col-sm-12 float-none">
                <div style="cursor: pointer" class="text-right form-group">
                  <a
                    v-if="accessObject?.is_add"
                    class="fill-btn cursor-pointer"
                    v-on:click="showBannerPopup"
                    >+ Add
                  </a>
                </div>
                <div class="card border mb-0 radius-15">
                  <div class="card-body p-0 pb-4">
                    <div class="table-responsive">
                      <div class="dataTables_wrapper dt-bootstrap4">
                        <table
                          class="table table-striped table-bordered dataTable"
                          style="width: 100%"
                          role="grid"
                          aria-describedby="example_info"
                        >
                          <thead>
                            <tr role="row">
                              <th>Sr. No.</th>
                              <th>Image</th>

                              <th
                                v-show="
                                  accessObject?.is_edit == 1 ||
                                  accessObject?.is_delete == 1
                                "
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody v-show="!loader">
                            <tr v-for="(data, index) in list" :key="index">
                              <td style="text-align: left">
                                {{
                                  ($refs.listPagination.currentPage - 1) * 10 +
                                  index +
                                  1
                                }}
                              </td>
                              <td>
                                <img
                                  :src="
                                    data.image
                                      ? data.image
                                      : '/images/placeholder.gif'
                                  "
                                  width="40"
                                  height="40"
                                  style="border-radius: 100px"
                                />
                              </td>
                              <td>
                                <a
                                  v-show="accessObject?.is_edit == 1"
                                  class="fill-btn btn-style cursor-pointer"
                                  v-on:click="showUpdateBannerPopup(index)"
                                  >Edit</a
                                >
                                <a
                                  v-show="accessObject?.is_delete == 1"
                                  class="fill-btn btn-style cursor-pointer"
                                  v-on:click="showDeletePopup(data)"
                                  >Delete</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="row mx-0 mb-4">
                      <div class="col-lg-12 mt-5 text-center">
                        <div class="page-bottom-pagination text-right">
                          <Pagination
                            @page-change="pageChange"
                            @items-per-page-change="itemsPerPageChange"
                            ref="listPagination"
                          />
                        </div>
                      </div>
                    </div>
                    <ErrorComponent @retry="getList()" ref="errorComponent" />
                    <TextModal ref="textModal">
                      <div class="modal-header">
                        <h5 class="modal-title">
                          {{ details.uuid ? "Edit" : "Add" }} Banner
                        </h5>
                        <button
                          type="button"
                          class="close"
                          v-on:click="$refs.textModal.closeModal"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <Form ref="bannerForm" @submit="uploadImage()">
                        <div class="modal-body">
                          <div class="col-lg-12 col-sm-12 mb-3">
                            <div class="text-center mb-4">
                              <img
                                :src="
                                  details.image && details.image != null
                                    ? details.image
                                    : '/images/placeholder.gif'
                                "
                                id="preview"
                                class="img-thumbnail"
                                style="
                                  border-radius: 100px;
                                  width: 120px;
                                  height: 120px;
                                "
                              /><br />
                              <div id="msg"></div>
                              <div
                                id="image-form"
                                style="margin: 0 auto; width: 90px"
                              >
                                <input
                                  type="file"
                                  class="file"
                                  id="pickFile"
                                  v-on:change="onChange($event)"
                                  accept="image/*"
                                  style="display: none"
                                />
                                <div class="input-group my-1">
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    placeholder="Upload File"
                                    id="file"
                                    style="display: none"
                                  />
                                  <div class="changePic" style="bottom: -25px">
                                    <label for="pickFile"> Change</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button id="save-button" class="fill-btn text-center">
                            Upload
                          </button>
                        </div>
                      </Form>
                    </TextModal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="text-center"
          style="margin-top: 20%"
          v-show="accessObject?.is_view == 0 || isShowAccessDeniedMessage"
        >
          <h3>You do not have access to view banner</h3>
        </div> -->
      </div>
    </div>
    <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
  </div>
</template>
<script>
import { Form } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import TextModal from "@/components/TextModal";
import Pagination from "@/components/Pagination";
export default {
  name: "Banner",
  components: {
    Form,
    ErrorComponent,
    DeleteModal,
    TextModal,
    Pagination,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage Banners"),
      loader: false,
      isShowAccessDeniedMessage: false,
      file: undefined,
      image: "",
      searchObj: {
        keyword: "",
      },
      details: {
        uuid: "",
      },
      list: [],
    };
  },
  mounted() {
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    this.$helperService.showMenu("true");
    this.getList(0);
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/banner/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          this.accessObject =
            this.$helperService.getAccessLevel("Manage Banners");
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Banner Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          this.$refs.errorComponent.updateListLoader(false);
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
          }
        });
    },
    onChange(e) {
      let files = e.target.files;
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      const size = (files[0].size / 1024 / 1024).toFixed(2);
      if (size > 10) {
        alert("File must be less then 10 MB");
        return;
      }
      var tmppath = URL.createObjectURL(files[0]);
      this.file = files[0];
      document.getElementById("preview").src = tmppath;
    },
    showBannerPopup() {
      this.details = {};
      this.file = "";
      this.$refs.bannerForm.resetForm();
      this.$refs.textModal.showModal();
    },
    showUpdateBannerPopup(index) {
      this.details = {};
      this.details.uuid = this.list[index].uuid;
      this.details.image = this.list[index].image;
      this.$refs.bannerForm.resetForm();
      this.$refs.textModal.showModal();
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete Banner",
        "Are you sure you want to delete ",
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$api
        .deleteAPI({
          _action: "/banner/" + detail.uuid,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getList();
            this.$notify({
              type: "success",
              text: res.message,
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
    uploadImage() {
      if (this.details.uuid) {
        var obj = {};
        obj.uuid = this.details.uuid;
      }
      if (!this.file) {
        this.$notify({
          type: "error",
          text: "Image is already uploaded,Please select new image for upload",
        });
        return;
      }
      this.$api
        .uploadImageAPI({
          _action: "/banner",
          _key: "image",
          _file: this.file,
          _body: obj,
          _buttonId: "save-button",
        })
        .then(() => {
          this.$refs.textModal.closeModal();
          this.getList(0);
          this.$notify({
            type: "success",
            text: "Image is uploaded successfully",
          });
          this.$refs.bannerForm.resetForm();
          this.file = undefined;
        });
    },
  },
};
</script>
